// Normalisation des termes de recherche — source unique, côté navigateur.
//
// Pendant exact de `backend/src/utils/search.js` : les deux doivent rester
// alignés, une recherche filtrée en mémoire devant donner le même résultat que
// la même recherche servie par l'API.
//
// Règle : on ne conserve que les caractères alphanumériques, en minuscules. Tout
// le reste (espaces, tirets, underscores, points, apostrophes et guillemets y
// compris typographiques, ponctuation) est retiré **des deux côtés de la
// comparaison** — terme saisi ET valeur comparée. « ABC-123 », « ABC 123 »,
// « ABC.123 » et « ABC_123 » retournent donc les mêmes résultats que « ABC123 ».
//
// Les accents sont translittérés (é → e) plutôt que supprimés : sans cela,
// `[^a-z0-9]` mangerait la lettre accentuée elle-même et « Émile » deviendrait
// « mile ». Les ligatures `œ`/`æ` sont traitées à part — elles valent deux
// lettres, ce qu'une décomposition NFD ne produit pas.
export function normalizeSearch(value) {
  return String(value ?? '')
    .replace(/[œŒ]/g, 'oe')
    .replace(/[æÆ]/g, 'ae')
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '');
}

// Vrai si le terme recherché apparaît dans l'une des valeurs fournies, les deux
// côtés étant normalisés. Un terme vide ne filtre rien (renvoie `true`).
export function matchesSearch(terme, ...valeurs) {
  const q = normalizeSearch(terme);
  if (!q) return true;
  return valeurs.some(v => normalizeSearch(v).includes(q));
}
